import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        // 导入
        reportsImport: {
            apiPath: '/loader/uploadManage',
            properties: {
                type: {
                    type: 'string.options.select',
                    displayName: '导入报表',
                    options: [
                        {
                            id: 'ADD_BLACK_LIST_V2',
                            name: '批量上传黑名单',
                        },
                        {
                            id: 'UPDATE_SALES',
                            name: '批量上下架',
                        },
                        {
                            id: 'UPDATE_IMAGE',
                            name: '批量上传图片',
                        },
                        {
                            id: 'UPDATE_SHOW_NAME',
                            name: '批量修改展示名称',
                        },
                        {
                            id: 'INSERT_CATEGORY_SKU',
                            name: '批量导入商品',
                        },
                        {
                            id: 'UPDATE_PRE_SALE_BULK',
                            name: '批量预售设置',
                        },
                        {
                            id: 'UPDATE_PRE_SALE_TOTAL_STOCK',
                            name: '预售库存列表',
                        },
                        {
                            id: 'UPDATE_PRODUCT_HIDDEN',
                            name: '批量隐藏设置',
                        },
                        {
                            id: 'UPDATE_IMAGE_STYLE_CODE',
                            name: '按款号批量上传图片',
                        },
                        {
                            id: 'SHELF_LIST_SPU',
                            name: '禁止上架名单SPU导入',
                        },
                        {
                            id: 'SHELF_LIST_SKU',
                            name: '禁止上架名单SKU导入',
                        },
                        {
                            id: 'SHELF_UNLIST_SPU',
                            name: '禁止下架名单SPU导入',
                        },
                        {
                            id: 'SHELF_UNLIST_SKU',
                            name: '禁止下架名单SKU导入',
                        },
                        {
                            id: 'SHELF_SCHEDULE_SPU',
                            name: '定时上下架SPU导入',
                        },
                        {
                            id: 'SHELF_SCHEDULE_SKU',
                            name: '定时上下架SKU导入',
                        },
                        {
                            id: 'SHELF_MANUAL_SHELF',
                            name: '批量上下架导入',
                        },
                    ],
                },
                createTime: {
                    type: 'string',
                    displayName: '导入时间',
                },
                processTime: {
                    type: 'string',
                    displayName: '处理完成时间',
                },
                userName: {
                    type: 'string',
                    displayName: '操作人',
                },
                status: {
                    type: 'string.reports.status',
                    displayName: '导入结果',
                },
                reason: {
                    type: 'string.reports.reason',
                    displayName: '失败原因',
                },
                downloadUrl: {
                    type: 'string.reports.url',
                    displayName: '源文件',
                },
            },
            filters: {
                operator: {
                    type: 'string',
                    displayName: '操作人',
                    controlConfig: {
                        placeholder: 'blackRemark',
                    },
                },
                createTime: {
                    type: 'object.dateRange',
                    displayName: '导入时间',
                },
                processTime: {
                    type: 'object.dateRange',
                    displayName: '处理完成时间',
                },
            },
        },
        // 导出
        reportsExport: {
            apiPath: '/loader/exportQueQue',
            properties: {
                type: {
                    type: 'string.options.select',
                    displayName: '导出报表',
                    options: [
                        {
                            id: 'SALEORDER',
                            name: '销售订单报表',
                        },
                        {
                            id: 'POINTORDER',
                            name: '积分订单报表',
                        },
                        {
                            id: 'REFUND',
                            name: '退款报表',
                        },
                        {
                            id: 'AFTERSALES',
                            name: '售后报表',
                        },
                        {
                            id: 'PRODUCTS',
                            name: '商品资料报表',
                        },
                        {
                            id: 'BLACKSKU',
                            name: '商品黑名单报表',
                        },
                        {
                            id: 'PRESALESPRODUC',
                            name: '预售库存列表',
                        },
                        {
                            id: 'SHIPPING_ORDER',
                            name: '发货单报表',
                        },
                        {
                            id: 'WECHAT_BROADCAST',
                            name: '微信直播数据报表',
                        },
                    ],
                },
                createTime: {
                    type: 'string',
                    displayName: '导出时间',
                },
                processTime: {
                    type: 'string',
                    displayName: '处理完成时间',
                },
                userName: {
                    type: 'string',
                    displayName: '操作人',
                },
                status: {
                    type: 'string.reports.status',
                    displayName: '导出结果',
                },
                downloadUrl: {
                    type: 'string.reports.url',
                    displayName: '下载地址',
                },
            },
            filters: {
                operator: {
                    type: 'string',
                    displayName: '操作人',
                    controlConfig: {
                        placeholder: 'blackRemark',
                    },
                },
                createTime: {
                    type: 'object.dateRange',
                    displayName: '导出时间',
                },
                processTime: {
                    type: 'object.dateRange',
                    displayName: '处理完成时间',
                },
            },
        },
    },
    components: {
        ReportsImportPage: {
            component: 'Viewport',
        },

        ReportsImportView: {
            component: 'Card',
            entity: 'reportsImport',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    // 挂载顺序
                    {
                        component: 'ReportsImportDataFilter',
                    },
                    {
                        component: 'ReportsImportDataTable',
                    },
                ],
            },
        },

        ReportsImportDataTable: {
            component: 'DataTable',
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'type',
                },
                {
                    property: 'createTime',
                },
                {
                    property: 'processTime',
                },
                {
                    property: 'userName',
                },
                {
                    property: 'status',
                    displayConfig: {
                        conditionProperty: 'processResult',
                    },
                },
                {
                    property: 'reason',
                    displayConfig: {
                        conditionProperty: 'processResult',
                    },
                },
                {
                    property: 'downloadUrl',
                    displayConfig: {
                        textProperty: 'fileName',
                    },
                },
            ],
        },

        ReportsImportDataFilter: {
            // 筛选
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'operator',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'createTime',
                },
                {
                    property: 'processTime',
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        ReportsExportDataFilter: {
            // 筛选
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'operator',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'createTime',
                },
                {
                    property: 'processTime',
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        ReportsExportPage: {
            component: 'Viewport',
        },

        ReportsExportView: {
            component: 'Card',
            entity: 'reportsExport',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    // 挂载顺序
                    {
                        component: 'ReportsExportDataFilter',
                    },
                    {
                        component: 'ReportsExportDataTable',
                    },
                ],
            },
        },

        ReportsExportDataTable: {
            component: 'DataTable',
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'type',
                },
                {
                    property: 'createTime',
                },
                {
                    property: 'processTime',
                },
                {
                    property: 'userName',
                },
                {
                    property: 'status',
                    displayConfig: {
                        conditionProperty: 'processResult',
                    },
                },
                {
                    property: 'downloadUrl',
                    displayConfig: {
                        textProperty: 'fileName',
                        conditionProperty: 'showDownload',
                        isSignature: 'type',
                    },
                },
            ],
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/import',
                    breadcrumbName: '报表管理',
                    component: 'ReportsImportPage',
                    childRoutes: [
                        {
                            path: '/',
                            component: 'ReportsImportView',
                            breadcrumbName: '批量导入管理',
                        },
                    ],
                },
                {
                    path: '/export',
                    breadcrumbName: '报表管理',
                    component: 'ReportsExportPage',
                    childRoutes: [
                        {
                            path: '/',
                            component: 'ReportsExportView',
                            breadcrumbName: '报表导出管理',
                        },
                    ],
                },
            ],
        },
    ],
};
